import { createNamespace } from '../utils';

var _createNamespace = createNamespace('image-preview'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export { createComponent, bem };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.12.24@vant/es/image-preview/shared.js
// module id = 519
// module chunks = 362